import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/system';
import TUKELOGO from '../images/TUKE_logo.jpg';
import UPJSLOGO from '../images/UPJS_logo.jpg';
import UNLPLOGO from '../images/unlp_logo.jpg';

const whiteLogos = [
  UNLPLOGO,
  TUKELOGO,
  UPJSLOGO,
];

const darkLogos = [
  UNLPLOGO,
  TUKELOGO,
  UPJSLOGO,
];

const logoStyle = {
  width: '100px',
  height: '80px',
  margin: '0 32px',
};

export default function LogoCollection() {
  const theme = useTheme();
  const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;

  return (
    <Box id="logoCollection" sx={{ py: 4 }}>
      <Typography
        component="p"
        variant="subtitle2"
        align="center"
        sx={{ color: 'text.secondary' }}
      >
        Vyvinuté v spolupráci s
      </Typography>
      <Grid container sx={{ justifyContent: 'center', mt: 0.5, opacity: 0.6 }}>
        {logos.map((logo, index) => (
          <Grid item key={index}>
            <img
              src={logo}
              alt={`Logo univerzity${index + 1}`}
              style={logoStyle}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
